// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","root":"AutocompleteResults_root__p2NBW","empty":"AutocompleteResults_empty__+rJgG","spinner":"AutocompleteResults_spinner__+sjZz"};